import React from 'react'
import ZoneManagerApartmentList from '../../features/zoneManager/ZoneManagerApartmentList'

const ZoneManagerApartmentListPage = () => {
  return (
    <ZoneManagerApartmentList/>
  )
}

export default ZoneManagerApartmentListPage